import { Button, Modal, Text } from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';
import styles from './ManualTopupTransactionModal.module.css';
import { TopupInfo } from './TopupInfo';
import { useManualTopupTransactionModal } from './useManualTopupTransactionModal';

const ManualTopupTransactionModal = () => {
  const { getTranslation } = useTranslate();
  const { email, props, onClose, openManualTopup } =
    useManualTopupTransactionModal();

  return (
    <Modal show={!!props.requestId} onClose={onClose}>
      <Modal.Header showCloseButton showDivider>
        {getTranslation('topup_manualTopup_titleSummary')}
      </Modal.Header>
      <Modal.Body className={styles.body}>
        <div className={styles.twoColumn}>
          <TopupInfo {...props} />
        </div>
        <Text textStyle={Text.Style.BodyMdRegular}>
          {`${getTranslation(
            'manualTopUpFormTransactionModal_text_sendTransMessage1',
          )} `}
          <Text tag="span" textStyle={Text.Style.BodyMdSemibold}>
            {email}
          </Text>
          {`. ${getTranslation(
            'manualTopUpFormTransactionModal_text_sendTransMessage2',
          )} `}
          <Text tag="span" textStyle={Text.Style.BodyMdSemibold}>
            {`${import.meta.env.VITE_BUSINESS_EMAIL} `}
          </Text>
          {getTranslation(
            'manualTopUpFormTransactionModal_text_sendTransMessage3',
          )}
        </Text>
        <Text textStyle={Text.Style.BodyMdRegular}>
          {getTranslation('topup_manualTopup_otherSubmit')}
          <Button buttonType={Button.Type.Text} onClick={openManualTopup}>
            {getTranslation('common_submitHere')}
          </Button>
        </Text>
      </Modal.Body>
    </Modal>
  );
};

export default ManualTopupTransactionModal;
